export default "__VITE_ASSET__vxPV8AUL__"